import React from 'react';
import { Table, Button, Card, Modal, message, Col, Popover} from 'antd';
import common from '../../assets/common.js';
import './index.css';
class Export extends React.Component {
  cancel = (id) =>{
    console.log(id)
  }
  constructor(){
    super();
    let table = {};
    table.id = "proTable";
    table = common.getDefaultTable(table);
    this.state = {
      table
    }
  }
  componentWillMount(){
    let this_ = this;
    this.showTableCol();
    // console.log(window.localStorage.getItem("userName"));
    if(window.localStorage.getItem("userName")) {
      let userName = window.localStorage.getItem("userName");
      let cardNo = window.localStorage.getItem("cardNo");
      this_.setState({
        userName,cardNo
      },() => {
          setTimeout(()=> {
            window.localStorage.clear("userName");
            window.localStorage.clear("cardNo");
          }, 1000);
      })
    }
  }
  componentDidMount(){
    this.getList();
  }
  showTableCol = () => {
    let table = this.state.table;
    table.columnsList = [{
      title: '开始时间',
      dataIndex: 'createTime',
      must: true,
      show: true,
      width: '100px'
    }, {
      title: '结束时间',
      dataIndex: 'etime',
      must: false,
      show: true,
      width: '100px'
    }, {
      title: '状态',
      dataIndex: 'statusName',
      must: true,
      show: true,
      width : "160px",
      render: (text, record) => {
        return (
          <div>
          {record.status === "EXPORT_SUCCESS"?<span style={{color: '#52C41A'}}>导出成功</span>:""}
          {record.status === "EXPORT_FAIL"?<span style={{color: '#F52E38'}}>导出失败</span>:""}
          {record.status === "EXPORT_ON"?<span style={{color: '#1890FF'}}>导出中</span>:""}
          </div>
        )
      }
    }, {
      title: '备注',
      dataIndex: 'remark',
      must: true,
      show: true,
      width : "120px"
    }, {
      title: '操作',
      align: "center",
      must: false,
      show: true,
      width: '100px',
      render: (text, record) => {
        return (
          <div>
            {record.status === 'EXPORT_SUCCESS'?<a onClick={ this.checkPrivileges.bind(this,record.dcOpenRecordExportId)}>附件下载</a>:<a disabled>附件下载</a>}
          </div>
        )
      }
    }];
    table = common.getEcardTable(table);
    // console.log(table);
    this.setState({ table });
  }
  changePage = (pagination, filters, sorter) => {
    const table = this.state.table;
    table.pagination = pagination;
    this.setState({ table })
    this.getList(pagination.current)
  }
  thisOk = () => {
    this.getList();
  }
  checkPrivileges = (id) => {
    var postData = {};
    postData["_url"] = "api/dc/open/record/export/detail/download";
    postData["_method"] = "GET";
    postData["id"] = id;
    common.request(postData, this, function(obj, data){
      const result = data.result;
      window.open(result);
    },function(obj, state){
    });
  }
  getList = (pageInfo, filters, sorter) =>{
    var this_ = this;
    const pn = pageInfo ? pageInfo: 1;
    const table = this.state.table;
    var postData = {};
    postData["_url"] = "api/dc/open/record/export/list";
    postData["pageNum"] = pn;
    table.loading = true;
    this.setState({ table });
    common.request(postData, this, function(obj, data){
      const result = data.result;
      obj.showList(result, pn);
    },function(obj, state){
      table.loading = false;
      obj.setState({ table });
    });
  }
  showList = (result, pn) => {
    const table = this.state.table;
    const list = result.list;
    table.loading = false;
    var dataSource = [];
    table.pagination = {
      current : pn,
      total : result.pageInfo.resultAmount,
    }
    common.eachObj(list, function(index, dataItem){
      var one = dataItem;
      one["key"] = (index + 1);
      one["orgId"] = dataItem.orgId;
      one["orgName"]= dataItem.orgName;
      one["userName"] = dataItem.userName;
      dataSource.push(one);
    })
    table.dataSource = dataSource;
    this.setState({ table });
  }
  showModal = (modalType, modalData) => {
    switch(modalType){
      case "releaseend":case "importend":
        this.getList();
        this.setState({ modalType, modalData });
        break;
      default:
        this.setState({ modalType, modalData });
        break;
    }
  }
  back = () => {
    this.props.history.goBack();
  }
  render(){
    const { table, passWDInfo } = this.state;
    return(
      <Card>
        <div>
          <Button type="primary" style={{marginBottom: '15px'}} onClick={ this.back }>返回</Button>
          <div id="manageTableDiv" className="table-div">
            { table.show && <Table
              { ...table }
              onChange={this.changePage.bind(this)}
            />}
            {/*<div className="table-total">共{ table.pagination.total }条数据</div>*/}
          </div>
        </div>
      </Card>
    )
  }
}
export default Export;



// WEBPACK FOOTER //
// ./src/component/record/export.js